import React from "react";
import { Button, Container, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import CustomButton from '../Components/CustomButton';

export default function Error() {
  return (
    <Container
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
      }}
    >
      <Container
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Typography variant="h1" sx={{
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            color: "#AD1C86",
            fontWeight: "bold",
            borderLeft: "5px solid #C49A4B",
            p: 1,
            textTransform: "uppercase",
          }}>404</Typography>
        <Typography
          variant="h6"
          style={{
            display: "flex",
            alignItems: "center",
            marginTop: "13px",
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            lineHeight: "1.8rem",
          }}
        >
          The page you’re looking for doesn’t exist.
        </Typography>
        <Link to="/">
          {" "}
          {/* <Button variant="contained" style={{ marginTop: "15px" }}>
            Back Home
          </Button> */}

          <CustomButton ButtonName={"Back Home"} />
        </Link>
      </Container>
    </Container>
  );
}